import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Column, Table } from '@tanstack/react-table';
import { TextField } from '@mui/material';

const ColumnFilterSearch = ({
  column,
  filterValue,
}: {
  column: Column<any, unknown>;
  filterValue?: any;
}) => {

  const {
    control,
  } = useForm<any>({
    mode: 'onChange',
  });

  const [value, setValue] = useState(filterValue ?? '');

  useEffect(() => {
    column.setFilterValue(value);
  }, [value]);

  return (
    <Controller
      control={control}
      name={'test'}
      defaultValue=""
      render={({ field }) => (
        <TextField
          type="text"
          placeholder="Search"
          InputLabelProps={{ shrink: true }}
          sx={{
            '& input': {
              padding: '5px !important',
              fontSize: '12px !important',
            }
          }}
          fullWidth
          {...field}
          value={value}
          onChange={e => setValue(e.target.value)}
        />
      )}
    />
  );
};

export default ColumnFilterSearch;